import React, { createContext, useContext, useState, useEffect } from 'react';
import jwt_decode from 'jwt-decode';

const AuthContext = createContext();

export const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuthStatus();
  }, []);

  const checkAuthStatus = () => {
    const token = localStorage.getItem('accessToken');
    
    if (!token) {
      setIsAuthenticated(false);
      setUser(null);
      setLoading(false);
      return;
    }

    try {
      const decodedToken = jwt_decode(token);
      const currentTime = Date.now() / 1000;
      
      // Kiểm tra token có hết hạn chưa
      if (decodedToken.exp < currentTime) {
        logout();
        return;
      }
      
      // Kiểm tra user có phải là admin không
      if (decodedToken.user && decodedToken.user.isAdmin) {
        setIsAuthenticated(true);
        setUser(decodedToken.user);
      } else {
        logout();
      }
    } catch (error) {
      console.error('Token không hợp lệ:', error);
      logout();
    }
    
    setLoading(false);
  };

  const login = (token) => {
    try {
      const decodedToken = jwt_decode(token);
      if (decodedToken.user && decodedToken.user.isAdmin) {
        localStorage.setItem('accessToken', token);
        setIsAuthenticated(true);
        setUser(decodedToken.user);
        return true;
      }
      return false;
    } catch (error) {
      console.error('Token không hợp lệ:', error);
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem('accessToken');
    setIsAuthenticated(false);
    setUser(null);
  };

  const refreshAuth = () => {
    checkAuthStatus();
  };

  const value = {
    isAuthenticated,
    user,
    loading,
    login,
    logout,
    refreshAuth
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}; 